import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { orderEvaluateDetail } from '../api/index';
export default {
  name: 'evaluateDetailDrawer',
  props: {
    /**
     * drawerVisible 抽屉显示状态
     */
    drawerVisible: {
      type: Boolean,
      default: false
    },
    /**
     * orderId 销售订单ID
     */
    orderId: {
      type: [Number, String],
      default: ''
    }
  },
  data: function data() {
    return {
      tableList: [],
      paging: {
        page: 1,
        page_size: 50,
        totalCount: 0
      },
      searchForm: {
        satisfied: [],
        tags_id: [],
        status: ''
      },
      searchOptions: {
        satisfied: [],
        tags_id: [],
        status: []
      }
    };
  },
  watch: {
    drawerVisible: function drawerVisible(val) {
      if (val) {
        this.resetState();
        this.fetchData();
      }
    }
  },
  methods: {
    // 重置状态
    resetState: function resetState() {
      this.paging = {
        page: 1,
        page_size: 50,
        totalCount: 0
      };
      this.searchForm = {
        satisfied: [],
        tags_id: [],
        status: ''
      };
      this.searchOptions = {
        satisfied: [],
        tags_id: [],
        status: []
      };
      this.tableList = [];
    },
    // 查询
    onSearch: function onSearch() {
      this.paging.page = 1;
      this.fetchData();
    },
    // 分页切换
    onPageChange: function onPageChange(val) {
      this.paging.page = val;
      this.fetchData();
    },
    // 每页条数切换
    onSizeChange: function onSizeChange(val) {
      this.paging.page_size = val;
      this.paging.page = 1;
      this.fetchData();
    },
    // 获取数据
    fetchData: function fetchData() {
      var _this = this;
      var params = {
        orderId: this.orderId,
        page: this.paging.page,
        page_size: this.paging.page_size
      };
      if (this.searchForm.satisfied.length) {
        params['satisfied'] = this.searchForm.satisfied;
      }
      if (this.searchForm.tags_id.length) {
        params['tags_id'] = this.searchForm.tags_id;
      }
      if (this.searchForm.status !== '') {
        params.status = this.searchForm.status;
      }
      orderEvaluateDetail(params).then(function (res) {
        _this.tableList = res.data.list || [];
        _this.paging.totalCount = res.data.total || 0;
        if (res.data.search_options) {
          _this.searchOptions = res.data.search_options;
        }
      });
    },
    // 关闭抽屉
    handleClose: function handleClose() {
      this.$emit('close');
    }
  }
};